export type StatusKeyBill = 'Vigente' | 'Cancelado' | 'En Proceso';

type BillStatus = {
  color: string;
};

export const statusBillColors: Record<StatusKeyBill, BillStatus> = {
  Vigente: { color: 'green' },
  Cancelado: { color: 'red' },
  'En Proceso': { color: 'blue' },
};

